import actions from './action';
import mutations from './mutations';
import getters from './getters';
export const state = { authToken: undefined, otpCode: undefined, nextRoute: undefined, isOtpCodeToSend: false };
const namespaced = true;
const authModule = { state, actions, mutations, getters, namespaced };
export default authModule;
